import { render, staticRenderFns } from "./ComponentDaysTableColumn.vue?vue&type=template&id=88d2b14e&"
import script from "./ComponentDaysTableColumn.vue?vue&type=script&lang=ts&"
export * from "./ComponentDaysTableColumn.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentDaysTableColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports